(function () {
  if (window.__sphMenuInit) return;
  window.__sphMenuInit = true;

  document.addEventListener('click', function (e) {
    var topTab = e.target.closest('.hdt-mobile-tab-btn');
    if (topTab) {
      var scope = topTab.closest('.hdt-mobile-tabs-content') || topTab.parentElement.parentElement;
      var target = topTab.getAttribute('data-tab');

      scope.querySelectorAll('.hdt-mobile-tab-btn').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      topTab.setAttribute('aria-current', 'true');

      scope.querySelectorAll('.hdt-mobile-tab-panel').forEach(function (p) {
        p.style.display = p.getAttribute('data-tab-panel') === target ? 'block' : 'none';
      });

      var otherContent = scope.parentElement.querySelector('.hdt-mobile-other-content');
      if (otherContent) otherContent.style.display = target === 'categories' ? 'none' : '';
      return;
    }

    var sphTab = e.target.closest('.sph-tab');
    if (sphTab) {
      var panelScope = sphTab.closest('.hdt-mobile-tab-panel') || document;
      var index = sphTab.getAttribute('data-sph-tab');

      panelScope.querySelectorAll('.sph-tab').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panelScope.querySelectorAll('.sph-panel').forEach(function (p) {
        p.classList.remove('is-active');
      });

      sphTab.classList.add('is-active');
      sphTab.setAttribute('aria-selected', 'true');
      var panel = panelScope.querySelector('.sph-panel[data-sph-panel="' + index + '"]');
      if (panel) panel.classList.add('is-active');
    }
  });
})();
